export const UPDATE_AUTH = (state: any, auth: any) => {
  state.federatedLoginService = auth;
};

export const UPDATE_USER = (state: any, user: any) => {
  state.user = user;
};

export const CLEAR_ALL_DATA = (state: any) => {
  // Auth
  state.auth.isLoggedIn = false;
  state.auth.accessToken = null;
  state.auth.refreshToken = null;

  // User
  state.user.name = '';
};
